import * as React from 'react';
import { Box, List, Typography } from '@mui/material';

import { CategoryServiceItem } from '.';
import { IZoneCategoryDefaultServiceItem } from 'models';

interface CategoryServiceItemListProps {
  serviceItems: Array<IZoneCategoryDefaultServiceItem>;
}

export const CategoryServiceItemList: React.FC<CategoryServiceItemListProps> = ({ serviceItems }) => {
  return serviceItems && serviceItems.length > 0 ? (
    <List>
      {serviceItems.map((item) => (
        <CategoryServiceItem key={`category-service-item-${item.id}`} serviceItem={item} />
      ))}
    </List>
  ) : (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: 120,
      }}
    >
      <Typography color="textSecondary">No default service items</Typography>
    </Box>
  );
};
